/* eslint-disable prettier/prettier */
import { useSetState } from 'ahooks'
import { Checkbox, Popup, Tabs } from 'antd-mobile'
import { cloneDeep } from 'lodash-es'
import { observer } from 'mobx-react'
import React, { useContext, useEffect, useMemo } from 'react'

import { HPopup, HSearchBar, SvgIcon } from '@/components'
import { useEventManager } from '@/components/EventManagerProvider'
import HErrorBlock from '@/components/HErrorBlock'
import { storeWithContext } from '@/store'
import { calculateColor } from '@/utils'

import HCell from '../../HYBVant/HCell'
import usePopup from '../../HYBVant/HPopup/hooks/usePopup'

import './index.less'

const List: React.FC<any> = ({
  value,
  onConfirm,
  fieldNames = { label: 'name', value: 'id' },
  disabled,
  renderLabel,
  label
}: any) => {
  const { deviceIsPortrait } = useContext(storeWithContext)
  const { open, modalData, setModalData, onOpen, onCancel, onOk } = usePopup({
    afterOk: async () => {
      onConfirm(modalData?.value)
      return Promise.resolve(1)
    }
  })
  // console.log(toJS(tabListMap[scheduleTableOperType]), toJS(mode), '888')
  const handleAddOrDel = (data: any, isChecked: boolean) => {
    const newValue = cloneDeep(modalData?.value || [])
    if (isChecked) {
      const newIndex = newValue.findIndex((item: any) => item === data[fieldNames?.value])
      newValue.splice(newIndex, 1)
    } else {
      newValue.push(data[fieldNames?.value])
    }
    setModalData({ value: newValue })
  }
  const eventManager = useEventManager()
  const setDataSource = (_: any) => setModalData({ dataSource: _ })
  const initValue = value
  useEffect(() => {
    setModalData({ value: value || [] })
  }, [initValue])
  useEffect(() => {
    eventManager?.on('CardSelect.setDataSource', setDataSource)
    return () => {
      eventManager?.off('CardSelect.setDataSource', setDataSource)
    }
  }, [])

  const listData = useMemo(() => {
    return modalData?.dataSource?.filter((item: any) =>
      modalData?.keyword ? item.keyword?.match(modalData?.keyword) : true
    )
  }, [modalData?.dataSource, modalData?.keyword])

  console.log('modalDaata', modalData)
  return (
    <>
      {renderLabel ? (
        renderLabel({ value, onClick: onOpen, disabled })
      ) : (
        <HCell
          value={value
            ?.map?.(
              (item: any) =>
                modalData?.dataSource?.find((i: any) => i[fieldNames.value] === item)?.[
                  fieldNames.label
                ]
            )
            .join('；')}
          onClick={() => onOpen({ value: value || [] })}
          disabled={disabled}
        />
      )}
      <HPopup className='card-select-popup-wrapper' visible={open} onClose={onCancel} onOk={onOk}>
        <div className='card-select-main-wrapper'>
          <HSearchBar
            className='card-select-main-search'
            value={modalData?.keyword}
            onChange={(e: any) => {
              setModalData({ keyword: e })
            }}
            placeholder='搜索'
          />
          <div className='card-select-list'>
            <div className='card-select-list-content'>
              {listData?.length > 0 ? (
                listData?.map((item: any) => {
                  // 判断是否选中
                  const isChecked = modalData?.value?.includes(item?.[fieldNames?.value])
                  return (
                    <div
                      key={item?.[fieldNames?.value]}
                      className='card-select-list-content-item'
                      onClick={() =>
                        handleAddOrDel(item, modalData?.value?.includes(item?.[fieldNames?.value]))
                      }
                    >
                      <div
                        className='card-select-list-content-card'
                        style={
                          item?.color
                            ? {
                                backgroundColor: item?.color,
                                color: calculateColor(item?.color)
                              }
                            : {}
                        }
                      >
                        {item?.text}
                      </div>
                      {isChecked && (
                        <SvgIcon
                          className='card-select-list-content-item-checked'
                          name={`schedule-checked${deviceIsPortrait ? '' : '-round'}`}
                        />
                      )}
                    </div>
                  )
                })
              ) : (
                <HErrorBlock className='advanced-empty-wrap' title='暂无数据' />
              )}
            </div>
          </div>
        </div>
      </HPopup>
    </>
  )
}

export default observer(List)
